(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bizafrika-service-enquiry"] && !Shopify.designMode) return;
  try {
    const stabilizeServiceAnchor = (root, frame) => {
    if (window.location.hash !== '#enquire' || !window.ResizeObserver) return;
    let active = true;
    const align = () => window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      if (active && window.location.hash === '#enquire') root.scrollIntoView({ behavior: 'instant', block: 'start' });
    }));
    const observer = new window.ResizeObserver(align);
    const events = ['pointerdown', 'wheel', 'touchstart', 'keydown'];
    const stop = () => {
      active = false;
      observer.disconnect();
      events.forEach((name) => document.removeEventListener(name, stop, true));
      window.removeEventListener('blur', stop);
      frame.removeEventListener('load', align);
      window.clearTimeout(timeout);
    };
    events.forEach((name) => document.addEventListener(name, stop, { capture: true, once: true, passive: true }));
    window.addEventListener('blur', stop, { once: true });
    frame.addEventListener('load', align);
    observer.observe(frame);
    const timeout = window.setTimeout(stop, 10000);
  };
  const initializeServiceForms = () => {
    document.querySelectorAll('[data-bizafrika-service-form]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      const frame = root.querySelector('[data-bizafrika-service-frame]');
      const fallback = root.querySelector('[data-bizafrika-service-fallback]');
      if (!frame || !fallback) return;
      const destination = new URL(root.dataset.formUrl);
      if (destination.origin !== 'https://api.untappedai.co.za' || destination.pathname !== '/widget/form/T4OWS85N7KG00lEdg55G') return;
      if (!window.crypto?.randomUUID) return;
      const reference = root.dataset.serviceReference || window.crypto.randomUUID();
      root.dataset.serviceReference = reference;
      destination.searchParams.set('service_reference', reference);
      destination.searchParams.set('service_page', window.location.origin + window.location.pathname);
      if (root.dataset.serviceType) destination.searchParams.set('service_type', root.dataset.serviceType);
      fallback.href = destination.href;
      frame.src = destination.href;
      frame.hidden = false;
      root.dataset.initialized = 'true';
      stabilizeServiceAnchor(root, frame);
      if (!document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]')) {
        const helper = document.createElement('script');
        helper.src = 'https://link.msgsndr.com/js/form_embed.js';
        helper.defer = true;
        document.body.appendChild(helper);
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeServiceForms, { once: true });
  } else {
    initializeServiceForms();
  }
  document.addEventListener('shopify:section:load', initializeServiceForms);
  } catch(e) { console.error(e); }
})();

})();
